import $ from 'jquery';

export default function smoothScrollToElement() {
    $('.course-details-content-header-arrow').on('click', function() {
        $('html,body').animate({ scrollTop: $('.course-details-content-header-arrow').offset().top }, 'slow');
        return false;
    });
}
